import m from "qs";
const o = (e) => (a) => e.get("/map-templates", {
  params: a
}), s = (e) => (a) => e.get(`/map-templates/${a.mapTemplateId}`), n = (e) => (a) => {
  const t = m.stringify({
    limit: a.limit,
    offset: a.offset,
    shared: a.shared
  });
  return e.get(`/map-document?${t}`, {});
}, u = (e) => (a) => e.get(`/map-document/${a.mapDocumentId}`), d = (e) => () => e.get("/map-document/last-saved-map"), c = (e) => (a) => e.post("/map-document/new", {
  mapTemplateId: a.mapTemplateId,
  mapDocument: a.mapDocument
}), l = (e) => (a) => e.put(`/map-document/${a.mapDocumentId}`, {
  mapDocumentUpdates: a.mapDocumentUpdates
}), i = (e) => (a) => e.delete(`/map-document/${a.mapDocumentId}`), r = (e) => (a) => e.put(`/map-document/${a.mapDocumentId}/share`, {
  sendEmailToAccount: !!a.sendEmailToAccount,
  description: a.description
}), D = (e) => (a) => e.get(
  `/portfolio-management/upload-pois/${a.jobId}/status`
), g = (e) => (a) => e.post("/portfolio-management/upload-pois", {
  rowData: a.rowData,
  tagName: a.tagName
});
export {
  c as createMapDocument,
  i as deleteMapDocument,
  d as getLastSavedMapDocument,
  u as getMapDocument,
  s as getMapTemplate,
  D as getUploadPoisJobStatus,
  n as listMapDocuments,
  o as listMapTemplates,
  r as shareMapDocument,
  l as updateMapDocument,
  g as uploadPoisJob
};
//# sourceMappingURL=index.es490.js.map
